import { Navbar } from '../components/Navbar'
import { HeroSection } from '../sections/HeroSection'
import { ProductShowcase } from '../sections/ProductShowcase'
import { LiveStats } from '../sections/LiveStats'
import { SecurityManagement } from '../sections/SecurityManagement'
import { PricingSection } from '../sections/PricingSection'
import { DownloadsSection } from '../sections/DownloadsSection'
import { SiteFooter } from '../sections/SiteFooter'

export function LandingPage() {
  return (
    <div className="min-h-screen bg-nexus-black text-white">
      <Navbar />
      <div className="relative overflow-hidden" id="inicio">
        <div className="pointer-events-none absolute inset-0 bg-radial-glow" />
        <HeroSection />
      </div>

      <main>
        <ProductShowcase />
        <LiveStats />
        <PricingSection />
        <div id="gestion">
          <SecurityManagement />
        </div>
        <div id="descargas">
          <DownloadsSection />
        </div>
      </main>

      <SiteFooter />
    </div>
  )
}


